export default [{
    path: '/wallet/consumerWallet',
    name: 'consumerWallet',
    meta: {
      index: 15
    },
    component: () => import('@/views/wallet/consumerWallet.vue')
  }]
  